// extracted by mini-css-extract-plugin
export var externalLink = "_bj-0";
export var internalLinkLabel = "_bj-1";